import { Component, OnInit } from '@angular/core';
import { LoginserviceService } from './loginservice.service';
import { Router } from '@angular/router';
import { AlertService } from 'ngx-alerts';
import { SessionStorageService } from 'ngx-webstorage';
import { CookieService} from 'ngx-cookie-service';
import { FormBuilder, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-log-in',
  templateUrl: './log-in.component.html',
  styleUrls: ['./log-in.component.css']
})
export class LogInComponent implements OnInit {
    errors: string;
    logForm: any;

  constructor(private spinner: NgxSpinnerService, private loginservice: LoginserviceService, private formBuilder: FormBuilder, private routes: Router, private alertService: AlertService, private session: SessionStorageService, private cookieService: CookieService) {
    this.logForm = this.formBuilder.group({
      'username': ['', Validators.required],
      'password': ['', [Validators.required,Validators.maxLength(12)]],
    });
  }
  
  ngOnInit() {
  }
  submit() {
    if(!this.logForm.valid){
      Object.keys(this.logForm.controls).forEach(field => { 
        const control = this.logForm.get(field);           
        control.markAsDirty({ onlySelf: true }); 
      });
      return;
    }
    this.spinner.show();
      this.loginservice.check(this.logForm.value.username, this.logForm.value.password).then((res: any) => {
          this.spinner.hide()
        this.alertService.success('Successfully loggedin');
        this.routes.navigate(['/main/profilesettings']);
        this.session.store('token', res.token);
        this.session.store('username', this.logForm.value.username);
        
        // if(res.mail_verify==='1'){
        //  this.spinner.hide();
        //   const emaildata = this.logForm.value.email;
        //   this.alertService.success('Successfully loggedin');
        //   this.routes.navigate(['/main/profilesettings']);
        //   this.session.store('token', res.token);
        //   this.cookieService.set( 'email', emaildata );
        //   this.cookieService.set( 'contractaddress', res.contract_address );
        //   this.cookieService.set( 'address', res.address );
        // }else{
        //   this.spinner.hide();
        //   this.session.store('semail', this.logForm.value.email);
        //   this.alertService.danger(res.message);
        //   this.routes.navigate(['/login']);
        // }
      }).catch((err: any) => {this.alertService.danger(err.message);
        this.spinner.hide(); }); 
  }
}
